<div
  *ngIf="component.config.helpText"
  class="help-text"
  [ngClass]="component.config.styleClasses"
  [innerHTML]="$any(component.config.helpText) | bindTemplate:response.data"
  data-test="help-text"
>
</div>
